export const BRAND = {
  name: "MERIDIAN",
  full: "Meridian Bed Bug Treatment",
  tagline: "Different Bug. Different Battle.",
  phoneDisplay: "(672) 673-7803",
  phoneTel: "+16726737803",
  areas: [
    "Vancouver", "Burnaby", "Richmond", "Surrey",
    "Coquitlam", "North Vancouver", "New Westminster",
    "West Vancouver", "Delta"
  ]
};

export const navLinks = [
  { label: "The Difference", href: "#difference" },
  { label: "Why Bed Bugs", href: "#why" },
  { label: "Treatment", href: "#treatment" },
  { label: "Preparation", href: "#preparation" },
  { label: "Areas", href: "#areas", route: "/bed-bug-treatment-areas" },
  { label: "Properties", href: "#residential" },
  { label: "Guide", href: "#guide", route: "/guide" },
  { label: "FAQ", href: "#faq" }
];